import { theme } from "themes/default/theme"

const popoverRadius = 5

const opositeSide = {
  top: "bottom",
  bottom: "top",
  right: "left",
  left: "right",
}

function doArrow(position, verticalAlign, horizontalAlign) {
  if (!position || position === "custom") {
    return {}
  }

  const width = 16
  const height = 12
  const color = "white"
  const isVertical = position === "top" || position === "bottom"
  const spaceFromSide = 10

  const obj = {
    [`--rtp-arrow-${
      isVertical ? opositeSide[horizontalAlign] : verticalAlign
    }`]: height + spaceFromSide + "px",
    [`--rtp-arrow-${opositeSide[position]}`]: -height + 2 + "px",
    [`--rtp-arrow-border-${isVertical ? "left" : "top"}`]: `${
      width / 2
    }px solid transparent`,
    [`--rtp-arrow-border-${isVertical ? "right" : "bottom"}`]: `${
      width / 2
    }px solid transparent`,
    [`--rtp-arrow-border-${position}`]: `${height}px solid ${color}`,
  }
  return obj
}

export const styles = {
  tour: {
    popover: (base, state) => ({
      ...base,
      "--reactour-accent": theme.palette.primary.main,
      borderRadius: popoverRadius,
      margin: popoverRadius,
      padding: 15,
      color: "#2d2d2d",
      boxShadow: "0 1px 10px #0006",
      marginTop:
        state.position === "bottom"
          ? 10
          : state.position === "top"
          ? -10
          : popoverRadius,
      marginLeft:
        state.position === "right"
          ? 10
          : state.position === "left"
          ? -10
          : popoverRadius,
      ...doArrow(state.position, state.verticalAlign, state.horizontalAlign),
    }),
    maskArea: (base) => ({ ...base, rx: popoverRadius }),
    // maskWrapper: (base) => ({ ...base, color: '#ef5a3d' }),
    badge: (base) => ({ ...base, right: "auto", left: "-0.8125em" }),
    controls: (base) => ({ ...base, marginTop: 0 }),
    close: (base) => ({ ...base, right: "auto", left: 8, top: 8 }),
  },
}
